'use strict';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var SDK_ENV = "prod" ;
var addressMap = {
    dev: '/dist',
    prod: 'https://deo.shopeemobile.com/shopee/shopee-trackingsdk-live-sg',
    staging: 'https://tms.traffic.staging.shopee.io/sdk',
    test: 'https://tms.traffic.test.shopee.io/sdk',
};
var CDNAddress = addressMap[SDK_ENV];

var DEFAULT_TRACKING_LOADER_VERSION = '1.1.0';
var injectTrackingLoader = function () {
    var loaderVersion = "@shopee/tracking-loader@".concat(trackingSDK.version, ".min.js");
    var s = document.createElement('script');
    s.async = true;
    s.src = "".concat(CDNAddress, "/").concat(loaderVersion);
    document.body.appendChild(s);
};
var privStore = {
    initialized: false,
};
var trackingSDK = {
    version: DEFAULT_TRACKING_LOADER_VERSION,
    store: {},
    load: function (modules) {
        if (Array.isArray(modules)) {
            trackingSDK.dep = __spreadArray(__spreadArray([], (trackingSDK.dep || []), true), modules, true);
            modules.forEach(function (m) {
                var _a;
                (_a = trackingSDK.__generateModule) === null || _a === void 0 ? void 0 : _a.call(trackingSDK, typeof m === 'string' ? m : m[0]);
            });
        }
    },
    init: function (dep, param, version) {
        if (version === void 0) { version = DEFAULT_TRACKING_LOADER_VERSION; }
        if (privStore.initialized) {
            console.warn('trackingSDK is already initialized.');
            return;
        }
        privStore.initialized = true;
        // dep: ['ubt', 'apms'], param: {...others} || function
        trackingSDK.param = param;
        var depList = Array.isArray(dep) ? dep : Object.keys(dep);
        trackingSDK.dep = __spreadArray(__spreadArray([], depList, true), (trackingSDK.dep || []), true);
        trackingSDK.version = version;
        depList.forEach(function (m) {
            var _a;
            (_a = trackingSDK.__generateModule) === null || _a === void 0 ? void 0 : _a.call(trackingSDK, m);
        });
        injectTrackingLoader();
    },
    __generateModule: function (name) {
        /* loader prior to 1.1.9 assumes the existence of the store */
        trackingSDK.store = trackingSDK.store || {};
        trackingSDK.store[name] = trackingSDK.store[name] || [];
        trackingSDK[name] = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = trackingSDK.store) === null || _a === void 0 ? void 0 : _a[name].push(args);
        };
    },
};
if (!self.window.trackingSDK) {
    self.window.trackingSDK = trackingSDK;
}
else {
    console.error('trackingSDK should be a singleton.');
}
